<template>
  <div>
    <video autoplay loop>
      <source :src=this.getVideo type="video/mp4">
      This browser does not support the video tag.
    </video>
  </div>
</template>

<script>
import axios from "axios";
import weathercodes from './weathercodes';

export default {
  name: "VideoWeather",
  data() {
    return {
      isLoading: true,
      refreshTimer: null,
      weatherCode: null
    };
  },
  computed:{
    getVideo(){
      if(!this.isLoading && this.weatherCode){
        const currentCode = weathercodes.find(i => i.code === this.weatherCode)
        if(currentCode){
          return currentCode.video || 'default.mp4';
        }
      }
      return 'default.mp4'
    }
  },
  methods: {
    refreshWeather() {
      const url = "https://api.worldweatheronline.com/premium/v1/weather.ashx",
            urlQuery = new URLSearchParams(window.location.search);

      let currentLocation = "";

      if (urlQuery.get("location") !== null) {
        currentLocation = urlQuery.get("location");
      }
      axios
        .get(url, {
          params: {
            key: "eb498059c2164ed38dc123046191408",
            q: currentLocation,
            num_of_days: "1",
            format: "json",
            show_comments: "no",
            tp: "1"
          }
        })
        .then(result => {
          const currentWeather = result.data.data.weather[0].hourly[new Date().getHours()];
          if (currentWeather) {
               this.weatherCode = currentWeather.weatherCode;
               this.isLoading = false;
               console.log('Current weather code', this.weatherCode);
          }
        });
    }
  },
  created() {
    window.axios = axios
    this.refreshWeather();
    this.refreshTimer = setInterval(this.refreshWeather, 30 * 60 * 1000); // refresh news every 30 mins
  }
};
</script>

<style scoped>
  
</style>
